<%= turbo_stream.replace @clip %>
